import React from 'react';
import { useSelector } from 'react-redux';
import useMenuRedirect from 'containers/Menu/hooks/useMenuRedirect';
import usePremiumImgBreakpoints from 'containers/Player/hooks/usePremiumImgBreakpoints';

import { Button } from 'cvlib';

import { getTranslation } from 'utils/getTranslation';
import { PUSHTOHISTORY } from 'constants.js';
import './PremiumPage.scss';
import { useNavigate } from 'react-router-dom';
import { useVerifyIsMobile } from 'hooks/useVerifyIsMobile';
import { getContentListV1 } from 'utils/homologacion/homologacion';

const PremiumPage = ({ contentInfo }) => {
  const translations = useSelector(state => state.translations);
  const { navigateToChannel, nodesSelected } = useMenuRedirect();
  const { imgSrc } = usePremiumImgBreakpoints();
  const navigate = useNavigate();
  const { isMobile } = useVerifyIsMobile()

  const handleClick = e => {
    e.stopPropagation();

    const isLiveContent =
      getContentListV1?.IsLive(contentInfo);
    const url = contentInfo?.url || '';
    const path = window.location.origin;
    const groupId = contentInfo?.group_id;
    //Redireccionamiento
    if (contentInfo?.type === 'app_behaviour') {
      location.href = contentInfo?.app_behaviour;
    } else if (contentInfo?.type === 'special') {
      window.location = `${path}${url}`;
    } else if (contentInfo?.type === 'node') {
      navigate(`/${getRegion()}/${contentInfo?.section}`);
    } else if (isLiveContent) {
      navigateToChannel({ id: groupId }, navigate);
    } else {
      navigate(
        `/${getRegion()}/vcard/homeuser/${contentInfo?.title_uri}/${groupId}`,
      );
    }
  };

  return (
    <>
      <div className="premiumPage">
        <div className="imgContainer">
          <img
            className="imgContainer__image"
            alt="Imagen"
            src={contentInfo?.[imgSrc] || contentInfo?.image_default}
            height={isMobile ? 130 :503}
          />

          <Button
            className="imgContainer__button"
            type="red"
            onClick={handleClick}
          >
            {getTranslation(
              `${nodesSelected.code}_Image_TextoBotonPrimario`,
              translations,
            )}
          </Button>
        </div>
      </div>
    </>
  );
};

export default PremiumPage;
